import { z } from 'zod';

export const TARIFF_COMMENT_MAX_LENGTH = 500;
export const tariffCommentDraftSchema = z
  .string()
  .trim()
  .max(TARIFF_COMMENT_MAX_LENGTH);

export const commentSchema = z
  .object({
    id: z.guid(),
    text: z.string().trim().min(1),
    internal: z.boolean(),
    createdBy: z.guid().nullable(),
    createdAt: z.string(),
  })
  .extend({
    author: z
      .object({
        firstName: z.string().trim().min(1),
        lastName: z.string().trim().min(1),
        email: z.email(),
      })
      .nullable()
      .optional(),
  })
  .strict();

export const claimTariffCommentSchema = z
  .object({
    claimID: z.guid(),
    tariffID: z.guid(),
    commentID: z.guid(),
  })
  .strict();

export const claimCommentSchema = z
  .object({
    claimID: z.guid(),
    commentID: z.guid(),
  })
  .strict();

export type Comment = z.infer<typeof commentSchema>;
export type ClaimTariffComment = z.infer<typeof claimTariffCommentSchema>;
export type ClaimComment = z.infer<typeof claimCommentSchema>;
